module.exports = __webpack_public_path__ + "static/complete-poems-1031b8380fc850016f3347c0d22a436b.jpg";